// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main container */
.know-more-about-container {
    display: flex;
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: relative;
    box-sizing: border-box;
    min-height: calc(100vh - nav-height);
    margin-top: 80px;
}

/* Image section */
.know-more-image-section {
    width: 60%;
    position: relative;
    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
}

.know-more-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* Text section */
.know-more-text-section {
    width: 85%;
    background-color: #2FAAC6;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    clip-path: polygon(10% 0, 100% 0, 100% 100%, 0% 100%);
    margin-left: -6%;
}

/* Diagonal shaded line */
.know-more-about-container::before {
    content: "";
    position: absolute;
    z-index: 2;
    background: linear-gradient(to bottom right, rgb(16, 176, 216), rgba(214, 215, 219, 0));
    pointer-events: none;
    left: 39.5%;
    width: 3%;
    height: 150%;
    top: -25%;
    transform: skewX(-8deg) translate(-5px, 10px);
}

.know-more-text-section h1 {
    font-size: 3em;
    margin-bottom: 10px;
    z-index: 3;
    margin-top: -100px;
    font-family: Arial, Helvetica, sans-serif;
}

.know-more-text-section p {
    font-size: 1.5em;
    text-align: center;
    padding: 0 20px;
    z-index: 3;
    margin-top: 10px;
}

.container {
    display: flex;
    flex-direction: row;
    padding: 20px;
    gap: 20px;
}

.image-wrapper {
    flex: 1 1;
}

.image {
    width: 100%;
    max-width: 400px;
    border-radius: 8px;
}

.text-wrapper {
    flex: 2 1;
    padding: 10px;
}

.info-section {
    margin: 20px 0;
}





@media (max-width: 768px) {
    .know-more-about-container {
        flex-direction: column;
        height: auto;
    }

    .know-more-image-section {
        width: 100%;
        height: 55vh;
        clip-path: none;
    }

    .know-more-text-section {
        width: 100%;
        height: 35vh;
        margin-left: 0;
        clip-path: none;
        padding: 20px;
    }

    .know-more-text-section h1 {
        font-size: 2em;
        margin-right: 30px;
    }

    .know-more-text-section p {
        font-size: 1em;
        margin-right: 15px;
    }

    .know-more-about-container::before {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/KnowMoreFirstPage/KnowMoreFirstPage.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,aAAa;IACb,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,UAAU;IACV,kBAAkB;IAClB,sDAAsD;AAC1D;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA,iBAAiB;AACjB;IACI,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,qDAAqD;IACrD,gBAAgB;AACpB;;AAEA,yBAAyB;AACzB;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,uFAAuF;IACvF,oBAAoB;IACpB,WAAW;IACX,SAAS;IACT,YAAY;IACZ,SAAS;IACT,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;;;;;AAMA;IACI;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;QACd,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["/* Main container */\n.know-more-about-container {\n    display: flex;\n    height: 100%;\n    width: 100%;\n    overflow: hidden;\n    position: relative;\n    box-sizing: border-box;\n    min-height: calc(100vh - nav-height);\n    margin-top: 80px;\n}\n\n/* Image section */\n.know-more-image-section {\n    width: 60%;\n    position: relative;\n    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);\n}\n\n.know-more-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n/* Text section */\n.know-more-text-section {\n    width: 85%;\n    background-color: #2FAAC6;\n    color: white;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    clip-path: polygon(10% 0, 100% 0, 100% 100%, 0% 100%);\n    margin-left: -6%;\n}\n\n/* Diagonal shaded line */\n.know-more-about-container::before {\n    content: \"\";\n    position: absolute;\n    z-index: 2;\n    background: linear-gradient(to bottom right, rgb(16, 176, 216), rgba(214, 215, 219, 0));\n    pointer-events: none;\n    left: 39.5%;\n    width: 3%;\n    height: 150%;\n    top: -25%;\n    transform: skewX(-8deg) translate(-5px, 10px);\n}\n\n.know-more-text-section h1 {\n    font-size: 3em;\n    margin-bottom: 10px;\n    z-index: 3;\n    margin-top: -100px;\n    font-family: Arial, Helvetica, sans-serif;\n}\n\n.know-more-text-section p {\n    font-size: 1.5em;\n    text-align: center;\n    padding: 0 20px;\n    z-index: 3;\n    margin-top: 10px;\n}\n\n.container {\n    display: flex;\n    flex-direction: row;\n    padding: 20px;\n    gap: 20px;\n}\n\n.image-wrapper {\n    flex: 1;\n}\n\n.image {\n    width: 100%;\n    max-width: 400px;\n    border-radius: 8px;\n}\n\n.text-wrapper {\n    flex: 2;\n    padding: 10px;\n}\n\n.info-section {\n    margin: 20px 0;\n}\n\n\n\n\n\n@media (max-width: 768px) {\n    .know-more-about-container {\n        flex-direction: column;\n        height: auto;\n    }\n\n    .know-more-image-section {\n        width: 100%;\n        height: 55vh;\n        clip-path: none;\n    }\n\n    .know-more-text-section {\n        width: 100%;\n        height: 35vh;\n        margin-left: 0;\n        clip-path: none;\n        padding: 20px;\n    }\n\n    .know-more-text-section h1 {\n        font-size: 2em;\n        margin-right: 30px;\n    }\n\n    .know-more-text-section p {\n        font-size: 1em;\n        margin-right: 15px;\n    }\n\n    .know-more-about-container::before {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
